import React from 'react'
import Mensageria from '_views/mensageria'

const MensageriaForm = () => {
  return <Mensageria />
}

export default MensageriaForm
